module.exports = __webpack_public_path__ + "static/hero-desktop-8e4301e3cd544b290ae661ea0c2144aa.png";